import { render, staticRenderFns } from "./logout.pug?vue&type=template&id=0bf612a7&lang=pug&"
import script from "./logout.js?vue&type=script&lang=js&"
export * from "./logout.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bf612a7')) {
      api.createRecord('0bf612a7', component.options)
    } else {
      api.reload('0bf612a7', component.options)
    }
    module.hot.accept("./logout.pug?vue&type=template&id=0bf612a7&lang=pug&", function () {
      api.rerender('0bf612a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logout/index.vue"
export default component.exports